module.exports = "<div class=\"breadcrumbs\"\n     ng-if=\"$ctrl.pathElements\">\n\n\t<ul>\n\t\t<li ng-repeat=\"crumb in $ctrl.pathElements\"\n\t\t    class=\"crumb\"\n\t\t    ng-class=\"{last: $last && $ctrl.pathElements.length>1}\">\n\t\t\t<a ng-if=\"(!$last) || ($ctrl.pathElements.length === 1)\"\n\t\t\t   ng-click=\"$ctrl.onCrumbClick({crumb:crumb,depth:$index})\">{{crumb.label}}</a>\n\t\t\t<a ng-if=\"$last && $ctrl.pathElements.length>1\">{{crumb.label}}</a>\n\t\t</li>\n\t</ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/directives/jf-breadcrumbs/jf.breadcrumbs.view.html
// module id = 489
// module chunks = 7